import { useCallback } from 'react';
import { useClient } from '../api';
import { BREEDS_URL, UNKNOWN_ADORABLE_MIX } from './constants';

export { useBreeds } from './useBreeds';

const sortUnknownBreedFirst = breeds =>
  [...breeds].sort((a, b) => {
    if (a.label === UNKNOWN_ADORABLE_MIX) return -1;
    if (b.label === UNKNOWN_ADORABLE_MIX) return 1;
    return 0;
  });

export const useFetchBreeds = () => {
  const client = useClient();
  return useCallback(
    async term => {
      const searchPath = `${BREEDS_URL}${term ? `?term=${term}` : ''}`;
      const { data } = await client.get(searchPath);
      return data;
    },
    [client],
  );
};

export const useGetBreeds = () => {
  const fetchBreeds = useFetchBreeds();
  return useCallback(
    async term => {
      const data = await fetchBreeds(term);
      const breeds = data.map(({ name, id }) => ({ label: name, value: id }));
      return sortUnknownBreedFirst(breeds);
    },
    [fetchBreeds],
  );
};
